export default "__VITE_ASSET__1a550f6f__"